var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartData)?_c('GChart',{staticStyle:{"min-height":"100%"},attrs:{"type":"PieChart","data":_vm.chartData,"options":_vm.chartOptions}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }